import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { ButtonDecorator } from '../../components/ButtonDecorator/ButtonDecorator';
import { ModalDecorator } from '../../components/ModalDecorator/ModalDecorator';
import { Bem } from '../../service/Bem/Bem';
import { CreativesBatchItem } from '../BatchesList/typings';
import { PcodeStaticCanvasPreview } from '../PcodeStaticCanvasPreview/PcodeStaticCanvasPreview';

import './CommonCreativesViewer.css';
import * as keyset from './CommonCreativesViewer.i18n';

const i18n = i18nFactory(keyset);
const BLOCK = 'common-creatives-viewer';

class CreativePreview extends React.PureComponent<{
    item: CreativesBatchItem;
}> {
    render() {
        const { item } = this.props;
        const size = `${item.data.width}x${item.data.height}`;
        const urlParts = item.archiveURL.split('/');
        const archiveName = urlParts[urlParts.length - 1];

        return (
            <div
                className={Bem.cls(BLOCK, 'item', {
                    fits: item.fitsSizeFilter ? 'yes' : 'no'
                })}
            >
                <PcodeStaticCanvasPreview
                    key={item.id}
                    previewUrl={item.creativeURL}
                    currentSize={{
                        width: item.data.width,
                        height: item.data.height
                    }}
                />
                <div className={Bem.cls(BLOCK, 'item-controls')}>
                    {archiveName} — {size}
                </div>
            </div>
        );
    }
}

export class CommonCreativesViewer extends React.PureComponent<{
    items: CreativesBatchItem[];
    cancel: () => void;
}> {
    render() {
        const { items } = this.props;
        const batchName = items[0].name;

        return (
            <ModalDecorator
                theme={'clear'}
                hasClose={true}
                header={batchName}
                visible={true}
                onClose={this.props.cancel}
                footer={
                    <ButtonDecorator
                        cls={Bem.cls(BLOCK, 'footer-action')}
                        theme="normal"
                        size="n"
                        text={i18n('cancel')}
                        onClick={this.props.cancel}
                    />
                }
            >
                <div className={Bem.cls(BLOCK, 'scrollable')}>
                    {items.map(item => {
                        return <CreativePreview key={item.id} item={item} />;
                    })}
                </div>
            </ModalDecorator>
        );
    }
}
